import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
export const HUB_WIZARD = 'd004c72b-2ebf-4218-860a-97ad5e91f2cc';
export const LANDING_PAGE = 'c3cdc394-b333-4255-a973-51019941e1d0';
export const ADMIN_HUB_IMPORT = 'b829b2e8-dfed-452a-a601-46ac98b64849';
export const PUBLIC_HUB_IMPORT = '675f27dc-cdc1-4415-8523-96dd4f4e72e4';
export const ONBOARDING_CONSUMER = '5fbb8e5e-973b-47c3-8c97-1e7c469cd387';
export const PUBLIC_API = '7833d8c3-d7c6-4279-b553-be7d4c497399';
export const LISTINGS = '1ef60c99-c249-477b-a2a4-d181e18f35c8';
export const LOANS = 'b05f9b51-f510-4674-8365-ff792ac8bc24';
export const TRANSACTIONS = '159d0dd1-e497-498f-9e9b-4b37659cf5c2';

class LuHubSourceAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'lu-hub-source';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'lus/hub/sources';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'name',
            'slug',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return [];
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            name: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
        };
    }

}

export default LuHubSourceAppResource;
